/**
 * Human-readable rendering of an op log, for the proposal card's "what it
 * changes" list.
 *
 * Lives beside the catalog because `describeCall` is catalog metadata, but is
 * kept in its own module so the UI can import it without pulling in the
 * executors and their pan.do/ra dependencies.
 */
import type { Op } from '../core/types';
import { MUTATE_TOOLS } from './edit';

const BY_NAME = new Map(MUTATE_TOOLS.map((t) => [t.name, t]));

export function describeOps(ops: Op[]): string[] {
  return ops.map((op) => describeOp(op));
}

export function describeOp(op: Op): string {
  const tool = BY_NAME.get(op.tool);
  if (!tool) return op.tool;
  try {
    return tool.describeCall(op.args);
  } catch {
    // describeCall runs on recorded args that may predate a schema change;
    // a card that renders the tool name beats a card that throws.
    return op.tool;
  }
}
